import React from 'react';
import { ErrorBoundary, useErrorBoundary } from 'react-error-boundary';

type QueryErrorBoundaryProps = {
    children?: React.ReactNode;
};

export function QueryErrorBoundary(props: QueryErrorBoundaryProps) {
    const { children } = props;

    return (
        <ErrorBoundary
            onError={(error) => {
                if (error instanceof QueryError) {
                    window.location.reload();
                }
            }}
            fallbackRender={() => children}
        >
            {children}
        </ErrorBoundary>
    );
}

export function useQueryErrorBoundary() {
    const { showBoundary } = useErrorBoundary();

    const forcePageReload = React.useCallback(
        (error: Error) => {
            showBoundary(new QueryError(error.message));
        },
        [showBoundary],
    );

    return {
        forcePageReload,
    };
}

class QueryError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'QueryError';
    }
}
